import { ImageDto } from '~/backend/connector-api/connector-schemas';
import { Image3D } from '~/domain/patient/image3d';
import { createImageListItemView } from '~/domain/projections/factories';
import { parseWireDate } from '~/utils/date';

/** An image contours can be propagated onto, with what identifies it to the user. */
export type RegistrationTargetImage = {
    seriesId: string;
    modality: string;
    studyId?: string;
    label?: string;
    date?: Date;
    sliceCount?: number;
};

/** A target image from a connector session's image list. */
export function targetImageFromSession(
    image: ImageDto
): RegistrationTargetImage {
    return {
        seriesId: image.series_instance_uid ?? '',
        studyId: image.study_instance_uid ?? '',
        modality: image.modality ?? '',
        label: image.display_name ?? undefined,
        date: parseWireDate(image.date),
        sliceCount: image.z_size,
    };
}

/** A target image from a loaded image. */
export function targetImageFromImage(image: Image3D): RegistrationTargetImage {
    const view = createImageListItemView(image);
    return {
        seriesId: view.seriesInstanceUid,
        studyId: view.studyInstanceUid,
        modality: view.modality,
        label: view.label,
        date: view.seriesDate,
        sliceCount: view.sliceCount,
    };
}
